import { render, staticRenderFns } from "./mouthcarlist.vue?vue&type=template&id=44267325&"
import script from "./mouthcarlist.vue?vue&type=script&lang=js&"
export * from "./mouthcarlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports